import { useEffect, useState } from "react";
import {
    TableRow,
    TableCell,
    Box,
    Typography
} from '@mui/material';
import dayjs from 'dayjs';

import InvoiceDetails from "./InvoiceDetails";
import QuoteDetails from "./QuoteDetails";
import ExpandRowButton from './ExpandRowButton';
import PDFCell from "./PDFCell";
import COLORS from '../styles/colors.json';
import { formatPrice } from "../helpers/misc";
import CustomerId from './CustomerId';

const VOL_SOURCE = 'VOL';
const WORK_ORDER_TYPE = 'workOrder';
const DATA_TYPE_QUOTE = 'quote';

const isEven = (n) => {
    return n % 2 === 0;
}

const VehicleDetail = ({ vehicle }) => {
    const {
        year,
        make,
        model,
        vin,
        fleet_unit_id
    } = vehicle;

    return (
        <Box>
            <Typography variant="regular">
                {[year, make, model].join(' ')}
            </Typography>
            <Typography variant='small'>
                {vin ? `VIN: ${vin}` : null}
            </Typography>
            <Typography variant='small'>
                {fleet_unit_id ? `Fleet Unit Id: ${fleet_unit_id}` : null}
            </Typography>
        </Box>
    )
}

const CustomerName = ({ firstName, lastName, businessName }) => {
    
}

const Row = (props) => {
    const {
        row,
        dataType,
        dataTablePage,
        index,
        features
    } = props;

    const vehicle = row.vehicle || {};
    const customer = row.customer || {};
    
    const [expanded, setExpanded] = useState(false);
    
    let id;
    let date;
    let rowDetailComponent;

    if (dataType === 'invoice') {
        const {
            invoice_id,
            invoice_dt,
            details,
            comment
        } = row;
        id = invoice_id;
        date = invoice_dt;
        rowDetailComponent = 
            <InvoiceDetails
                open={expanded}
                invoice={details}
                comment={comment}
            />;
    } else if (dataType === 'quote') {
        const {
            quote_id,
            quote_dt,
            comment
        } = row;
        id = quote_id;
        date = quote_dt;

        rowDetailComponent =
            <QuoteDetails
                open={expanded}
                comment={comment}
                quotes={row}
                features={features}
            />;
    } else if (dataType === 'workOrder') {
        const {
            work_order_id,
            work_order_dt,
            details,
            comment
        } = row;
        id = work_order_id;
        date = work_order_dt;
        rowDetailComponent =
            <InvoiceDetails
                open={expanded}
                invoice={details}
                comment={comment}
            />;
    }


    useEffect(() => {
        setExpanded(false);
    }, [dataType, dataTablePage])

    const renderPDFCell = (source) => {
        return (
            <PDFCell
                id={id}
                dataType={dataType}
                source={row.source_system_code}
                timeZone={row.store_time_zone}
                documentDate={row.quote_dt || row.work_order_dt || row.invoice_dt}
                features={features}
            />
        )
    }

    const formatName = () => {
        const {
            first_name,
            last_name,
            business_name
        } = customer;

        if (business_name) {
            return business_name;
        } else {
            return [first_name, last_name].filter((name) => name !== undefined).join(' ');
        }
    }
    
    return (
        <>
            <TableRow
                key={index}
                sx={{ backgroundColor: isEven(index) ? COLORS.white : COLORS.gray5 }}
            >
                <TableCell>
                    {<ExpandRowButton
                        expanded={expanded}
                        handleClick={() => setExpanded(!expanded)}
                        />}
                </TableCell>
                <TableCell>
                    {renderPDFCell(row.source_system_code)}
                </TableCell>
                <TableCell>{dayjs(date).format('MM/DD/YYYY') }</TableCell>
                <TableCell align="right">{row.store_no}</TableCell>
                <TableCell>{id}</TableCell>
                <TableCell>{formatName()}</TableCell>
                <TableCell>
                    <CustomerId odsCustomerId={customer.ods_customer_id}>
                        {customer.source_customer_id}
                    </CustomerId>
                </TableCell>
                <TableCell>
                    <VehicleDetail vehicle={vehicle}/>
                </TableCell>
                <TableCell align="right">{vehicle.mileage}</TableCell>
                <TableCell>{vehicle.license_plate}</TableCell>
                {dataType !== DATA_TYPE_QUOTE ? <TableCell align="right">{formatPrice(row.total_amount)}</TableCell> : null}
            </TableRow>
            {rowDetailComponent}
        </>
    )
}

export default Row;